import { render, staticRenderFns } from "./QuotationTemplate.vue?vue&type=template&id=ba7b914e&scoped=true&"
import script from "./QuotationTemplate.vue?vue&type=script&lang=js&"
export * from "./QuotationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./QuotationTemplate.vue?vue&type=style&index=0&id=ba7b914e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7b914e",
  null
  
)

export default component.exports